import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { toggleBullet } from 'roosterjs-editor-api';

const bullets: RibbonButton = {
    key: 'bullets',
    title: () => strings.bullets,
    imageSrc: require('../svg/bullets.svg'),
    imageRtlSrc: require('../svg/bullets-rtl.svg'),
    shortcutWin: 'Ctrl+.',
    shortcutMac: '⌘+.',
    buttonState: formatState =>
        formatState.isBullet ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleBullet(plugin.getEditor()),
};

export default bullets;
